import ArkLoader from '@src/js/common/ark-extensions';
import { Toolbar } from '@tencent/workbench';
import { TemplateMachineAuditConfig } from './component-config';
import { ITemplateMachineAuditOptions, MachineAuditExtension } from './type';

function getAiComponent(): Promise<MachineAuditExtension> {
    const { name } = TemplateMachineAuditConfig;
    return ArkLoader.extensionService.getExtension(name);
}

export async function showTemplateMachineAudit(options: ITemplateMachineAuditOptions) {
    return (await getAiComponent()).show(options);
}

export async function getToolBarSchema() {
    return (await getAiComponent()).getToolbarSchema();
}

export async function getToolBarConfig() {
    return (await getAiComponent()).getToolbarConfig();
}

export async function getController() {
    const aiComponent = await getAiComponent();
    aiComponent.registerToolbar(Toolbar);
    return aiComponent.getController();
}
